import React, { useEffect, useState } from "react";
import tailoredIcon1 from "../images/Isolation_Mode.svg";
import tailoredIcon2 from "../images/Isolation_Mode (1).svg";
import tailoredIcon3 from "../images/Isolation_Mode (2).svg";
import tailoredIcon4 from "../images/Isolation_Mode (3).svg";
import tailoredIcon5 from "../images/Isolation_Mode (4).svg";

import { Button } from "@mui/material";
import arrow_btn from "../images/arrow_btn.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutOurCore = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const cardItem = [
    {
      icon: tailoredIcon1,
      title: t("innovation"),
      subTitle: t("innovation_desc"),
    },
    {
      icon: tailoredIcon2,
      title: t("security"),
      subTitle: t("security_desc"),
    },
    {
      icon: tailoredIcon3,
      title: t("transparency"),
      subTitle: t("transparency_desc"),
    },
    {
      icon: tailoredIcon4,
      title: t("agility"),
      subTitle: t("agility_desc"),
    },
    {
      icon: tailoredIcon5,
      title: t("collaboration"),
      subTitle: t("collaboration_desc"),
    },
  ];

  const cartItemSecond = [
    {
      icon: tailoredIcon4,
      title: t("agility"),
      subTitle: t("agility_desc"),
    },
    {
      icon: tailoredIcon5,
      title: t("collaboration"),
      subTitle: t("collaboration_desc"),
    },
  ];

  return (
    <div className="container mx-auto px-2 xl:max-w-[1200px] 3xl:max-w-[1400px]" >
      <div className="flex justify-center items-center pb-[10px] sm:pb-[30px]" id="OurCoreValues">
        <h1 className="sora text-[#141619]  text-[22px] sm:text-[32px] md:text-[35px] 3xl:text-[54px] font-[700] flex flex-col justify-center items-center">
          {t("our_core_values")}
        </h1>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {isWideScreen
          ? cardItem.slice(0, 3).map((item, i) => (
            // <div className="bg-red-500" key={i}>
            <div
              key={i}
              className="p-[16px] sm:p-5 lg:p-8 border border-[#dae2ff] rounded-[20px]"
              style={{
                backgroundImage: "linear-gradient(304deg, rgb(241 244 255) 8.68%, rgba(251, 245, 253, 0) 93.62%)",
              }}
            >
              <div className='w-[fit-content] border border-[#3359D3] rounded-[10px] p-2 sm:p-3 lg:p-4'><img draggable="false" src={item.icon} alt={`icon${i}`} /></div>
              <h1 className='sora font-[700] text-[18px] sm:text-[21px] mt-5'>{item.title}</h1>
              <span className='sora font-[400]  text-[14px] sm:text-[16px] mt-1'>{item.subTitle}</span>
            </div>
            // </div>
          ))
          : cardItem.map((item, i) => (
            <div
              key={i}
              className="p-[16px] sm:p-5 lg:p-8 border border-[#dae2ff] rounded-[20px]"
              style={{
                backgroundImage: "linear-gradient(304deg, rgb(241 244 255) 8.68%, rgba(251, 245, 253, 0) 93.62%)",
              }}
            >
              <div className='w-[fit-content] border border-[#3359D3] rounded-[10px] p-2 sm:p-3 lg:p-4'><img draggable="false" src={item.icon} alt={`icon${i}`} /></div>
              <h1 className='sora font-[700]  text-[18px] sm:text-[21px] mt-5'>{item.title}</h1>
              <span className='sora font-[400] text-[14px] sm:text-[16px] mt-1'>{item.subTitle}</span>
            </div>
          ))}
      </div>
      {isWideScreen && <div className="grid sm:grid-cols-2 mt-5 lg:grid-cols-6  gap-4">
        <div />
        {
          cartItemSecond.map((item, i) => {
            return (
              <div
                key={i}
                className="p-[16px] sm:p-5 lg:p-8 border border-[#dae2ff] rounded-[20px] col-span-2"
                style={{
                  backgroundImage: "linear-gradient(304deg, rgb(241 244 255) 8.68%, rgba(251, 245, 253, 0) 93.62%)",

                }}
              >
                <div className='w-[fit-content] border border-[#3359D3] rounded-[10px] p-2 sm:p-3 lg:p-4'><img draggable="false" src={item.icon} alt={`icon${i}`} /></div>
                <h1 className='sora font-[700]  text-[18px] sm:text-[21px] mt-5'>{item.title}</h1>
                <span className='sora font-[400] text-[14px] sm:text-[16px] mt-1'>{item.subTitle}</span>
              </div>
            )
          })
        }
      </div>}
      <div />
      {/* <div className="pt-7 flex justify-center">
        <div
          className="requestDemoBtnOuter "
          onClick={() => navigate("/contact-us")}
        >
          <Button className="requestDemoBtn">
            Request Demo
            <img draggable="false"
              src={arrow_btn}
              className="w-[9px] sm:w-[12px] ml-[4px]"
              alt="Arrow_up_small"
            />
          </Button>
        </div>
      </div> */}
    </div>
  );
};

export default AboutOurCore;
